// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__az4of","actions":"styles_actions__ISXH8"};